import React, { useRef, useEffect } from 'react';
// import { drawFishbone } from './drawFishbone'; 

const FishboneInfoGraphics = ({
    title,
    problem,
    cat1,
    cat2,
    cat3,
    cat4,
    cat5,
    cat6,
    cat1cause1,
    cat1cause2,
    cat2cause1,
    cat2cause2,
    cat3cause1,
    cat3cause2,
    cat4cause1,
    cat4cause2,
    cat5cause1,
    cat5cause2,
    cat6cause1,
    cat6cause2,
    fontSize,
    lineHeight,
    maxWidth,
    startXProblem,
    startYProblem,
    startXTitle,
    startYTitle,
    startXCat1,
    startYCat1,
    startXCat2,
    startYCat2,
    startXCat3,
    startYCat3,
    startXCat4,
    startYCat4,
    startXCat5,
    startYCat5,
    startXCat6,
    startYCat6,
    startXCat1Cause1,
    startYCat1Cause1,
    startXCat2Cause1,
    startYCat2Cause1,
    startXCat3Cause1,
    startYCat3Cause1,
    startXCat4Cause1,
    startYCat4Cause1,
    startXCat5Cause1,
    startYCat5Cause1,
    startXCat6Cause1,
    startYCat6Cause1,
    startXCat1Cause2,
    startYCat1Cause2,
    startXCat2Cause2,
    startYCat2Cause2,
    startXCat3Cause2,
    startYCat3Cause2,
    startXCat4Cause2,
    startYCat4Cause2,
    startXCat5Cause2,
    startYCat5Cause2,
    startXCat6Cause2,
    startYCat6Cause2,
    imageSrc,
    viewWidth
}) => {
    const canvasRef = useRef(null);

    function wrapText(ctx, text, x, y, maxWidth, lineHeight, textColor) {
        var words = text.split(' ');
        var line = '';
        for (var i = 0; i < words.length; i++) {
            var testLine = line + words[i] + ' ';
            var metrics = ctx.measureText(testLine);
            var testWidth = metrics.width;
            if (testWidth > maxWidth && i > 0) {
                ctx.fillText(line, x, y);
                line = words[i] + ' ';
                y += lineHeight;
            } else {
                line = testLine;
            }
        }
        ctx.fillText(line, x, y);
        ctx.fillStyle=textColor;
    }

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        maxWidth = viewWidth; //viewWidth;

        // Draw the image
        const image = new Image();
        image.onload = function () {
            canvas.width = image.width;
            canvas.height = image.height;

            ctx.drawImage(image, 0, 0);

            // Draw the elements
            ctx.font = `${fontSize}px Arial`;
            ctx.textAlign = 'center';
            maxWidth=40;
            wrapText(ctx, problem, startXProblem, startYProblem, maxWidth*6, lineHeight, 'white');

            wrapText(ctx, title, startXTitle, startYTitle, maxWidth*3, lineHeight, 'white');

            wrapText(ctx, cat1, startXCat1, startYCat1, maxWidth, lineHeight, 'white');
            wrapText(ctx, cat2, startXCat2, startYCat2, maxWidth, lineHeight, 'white');
            wrapText(ctx, cat3, startXCat3, startYCat3, maxWidth, lineHeight, 'white');
            wrapText(ctx, cat4, startXCat4, startYCat4, maxWidth, lineHeight, 'white');
            wrapText(ctx, cat5, startXCat5, startYCat5, maxWidth, lineHeight, 'white');
            wrapText(ctx, cat6, startXCat6, startYCat6, maxWidth, lineHeight, 'white');

            wrapText(ctx, cat1cause1, startXCat1Cause1, startYCat1Cause1, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat2cause1, startXCat2Cause1, startYCat2Cause1, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat3cause1, startXCat3Cause1, startYCat3Cause1, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat4cause1, startXCat4Cause1, startYCat4Cause1, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat5cause1, startXCat5Cause1, startYCat5Cause1, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat6cause1, startXCat6Cause1, startYCat6Cause1, maxWidth, lineHeight, 'blue');

            wrapText(ctx, cat1cause2, startXCat1Cause2, startYCat1Cause2, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat2cause2, startXCat2Cause2, startYCat2Cause2, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat3cause2, startXCat3Cause2, startYCat3Cause2, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat4cause2, startXCat4Cause2, startYCat4Cause2, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat5cause2, startXCat5Cause2, startYCat5Cause2, maxWidth, lineHeight, 'blue');
            wrapText(ctx, cat6cause2, startXCat6Cause2, startYCat6Cause2, maxWidth, lineHeight, 'blue');
            };
            image.src = imageSrc;
}, [
    title,
    problem,
    cat1,
    cat2,
    cat3,
    cat4,
    cat5,
    cat6,
    cat1cause1,
    cat1cause2,
    cat2cause1,
    cat2cause2,
    cat3cause1,
    cat3cause2,
    cat4cause1,
    cat4cause2,
    cat5cause1,
    cat5cause2,
    cat6cause1,
    cat6cause2,
    fontSize,
    lineHeight,
    maxWidth,
    startXProblem,
    startYProblem,
    startXTitle,
    startYTitle,
    startXCat1,
    startYCat1,
    startXCat2,
    startYCat2,
    startXCat3,
    startYCat3,
    startXCat4,
    startYCat4,
    startXCat5,
    startYCat5,
    startXCat6,
    startYCat6,
    startXCat1Cause1,
    startYCat1Cause1,
    startXCat2Cause1,
    startYCat2Cause1,
    startXCat3Cause1,
    startYCat3Cause1,
    startXCat4Cause1,
    startYCat4Cause1,
    startXCat5Cause1,
    startYCat5Cause1,
    startXCat6Cause1,
    startYCat6Cause1,
    startXCat1Cause2,
    startYCat1Cause2,
    startXCat2Cause2,
    startYCat2Cause2,
    startXCat3Cause2,
    startYCat3Cause2,
    startXCat4Cause2,
    startYCat4Cause2,
    startXCat5Cause2,
    startYCat5Cause2,
    startXCat6Cause2,
    startYCat6Cause2,
    imageSrc,
    viewWidth
]);

return (
    <canvas
        ref={canvasRef}
        style={{
            maxWidth: '100%',
        }}
    ></canvas>
);
};

export default FishboneInfoGraphics;
